<template>
  <Listbox v-slot="{ open }" v-model="selectedNumberOfPayments" :disabled="false" class="group">
    <div class="relative w-fit">
      <ListboxButton
          :class="[open ? '!border-grays-800' : '', 'relative cursor-pointer px-[8px] py-[8.5px] flex flex-row-reverse items-center justify-between w-fit rounded bg-white border border-grays-400 text-left group gap-[8px] hover:border-grays-600']"
      >
        <span
            :class="[open ? 'rotate-180 text-grays-800' : '', 'material-symbols-rounded text-grays-700 group-disabled:text-grays-600 text-[20px]']"
        >expand_more</span>
        <span
            class="text-sm w-[28px] leading-[21px] text-center text-grays-900 font-bold group-disabled:text-grays-600"
        >{{ selectedNumberOfPayments?.option }}</span>
      </ListboxButton>

      <transition
          leave-active-class="transition duration-100 ease-in"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
      >
        <ListboxOptions
            :class="openUp ? 'absolute mb-2 bottom-[40px] mt-0' : ''"
            class="custom-scroll-bar absolute mt-2 max-h-[107px] w-full overflow-auto rounded bg-white text-base shadow-tooltip z-10 gap-[8px]"
        >
          <ListboxOption
              v-for="numberOfPayment in numberOfPayments"
              :key="numberOfPayment.id"
              :value="numberOfPayment"
              class="cursor-pointer w-full hover:bg-gray_semantic px-[8px]"
          >
            <p class="text-sm text-grays-900 font-bold group-disabled:text-grays-600 leading-[24px]">
              {{ numberOfPayment.option }}
            </p>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>

<script>
import {Listbox, ListboxButton, ListboxOption, ListboxOptions} from "@headlessui/vue";

export default {
  name: "select-number",
  components: {
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
  },
  props: {
    openUp: {
      type: Boolean,
      default: false,
    },
    currentPayments: {
      type: Number,
      default: null,
    },
    maxNumber: {
      type: Number,
      default: null,
    },
  },
  emits: ["payment-changed"],
  data() {
    return {
      numberOfPayments: this.generateNumberOfPayments(),
      selectedNumberOfPayments: this.findCurrentPaymentOrDefault(),
      isMounted: false,
    };
  },
  watch: {
    currentPayments(newPayments) {
      if (this.isMounted) {
        this.selectedNumberOfPayments = this.findCurrentPaymentOrDefault();
      }
    },
    selectedNumberOfPayments(curr, prev) {
      if (this.isMounted && prev.option !== curr.option) {
        if (curr && curr.option) {
          this.$emit("payment-changed", +curr.option);
        }
      }
    },
    maxNumber(newMax, oldMax) {
      if (newMax !== oldMax) {
        this.numberOfPayments = this.generateNumberOfPayments();
        this.selectedNumberOfPayments = this.findCurrentPaymentOrDefault();
      }
    },
  },
  methods: {
    generateNumberOfPayments() {
      return Array.from({length: this.maxNumber}, (v, k) => ({id: k, option: `${k + 1}`}));
    },
    findCurrentPaymentOrDefault() {
      this.numberOfPayments = this.generateNumberOfPayments();
      return this.numberOfPayments.find((payment) => payment.option === `${this.currentPayments}`) || this.numberOfPayments[0];
    },
  },
  mounted() {
    this.selectedNumberOfPayments = this.findCurrentPaymentOrDefault();
    this.isMounted = true;
  },
};
</script>

<style>
/* Your styles here */
</style>
